<template>
    <div class="grid-x" id="mobile-topbar">
      <!-- Left: Mobile Burger Menu -->
      <div class="cell shrink left-section">
        <div class="grid-x align-center align-middle ">
            <burger-menu 
            :is-open="mobileMenuOpen"
            @toggle="toggleMobileMenu"
            />
            <router-link to="/" id="mobile-topbar-logo" class="grid-x align-center align-middle">
            <img src="@/assets/logo.svg" alt="horstCOSMOS Logo" loading="lazy" />
            </router-link>
        </div>
      </div>
  
      <!-- Center: Logo -->
      <div class="cell auto center-section">
      </div>
  
      <!-- Right: Mobile User Component -->
      <div class="cell shrink right-section">
        <mobile-topbar-user-component id="topbar-user-mobile" />
      </div>
  
      <!-- Mobile Navigation Menu -->
      <div class="mobile-nav" :class="{ 'mobile-nav-open': mobileMenuOpen }">
        <ul class="menu icons">
          <li v-for="(element, index) of filteredElements" 
              :key="index" 
              class="mobile-nav-item"
              @click="handleMobileItemClick">
            <template v-if="element.externalLink">
              <a :href="element.externalLink" target="_blank">
                <i :class="element.icon" class="bi" aria-hidden="true"></i>
                <span v-if="element.titleLocale">{{ $t(element.titleLocale) }}</span>
                <span v-else>{{ element.title }}</span>
              </a>
            </template>
            <router-link
              v-if="element.link"
              :to="element.link"
              :class="{ selected: activeElement.title.startsWith(element.title) }"
            >
              <i :class="element.icon" class="bi" aria-hidden="true"></i>
              <span v-if="element.titleLocale">{{ $t(element.titleLocale) }}</span>
              <span v-else>{{ element.title }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, computed, ref } from 'vue'
  import MobileTopbarUserComponent from './MobileTopbarUserComponent.vue'
  import BurgerMenu from './BurgerMenu.vue'
  import { useRoute } from 'vue-router'
  import { getMobileElements } from './Navbar/elementsMobile'
  import { getNavElements } from './Navbar/elements'
  import { authenticationInformation } from '@/oidc/authentication'
  
  export default defineComponent({
    name: 'MobileTopbar',
    components: {
      MobileTopbarUserComponent,
      BurgerMenu,
    },
  
    setup() {
      const route = useRoute()
      const user = authenticationInformation().user
      const mobileMenuOpen = ref(false)
  
      const elements = computed(() => {
        return getNavElements(user)
      })
  
      const filteredElements = computed(() => {
        return getMobileElements(user).filter((element) => element.visible === undefined || element.visible())
      })
  
      const activeElement = computed(() => {
        const active = elements.value.find(
          (elem, index) => index !== 0 && elem.link && route.path.startsWith(elem.link as string),
        )
        return active ? active : { title: 'no', icon: 'no' }
      })
  
      const toggleMobileMenu = () => {
        mobileMenuOpen.value = !mobileMenuOpen.value
      }
  
      const handleMobileItemClick = () => {
        mobileMenuOpen.value = false
      }
  
      return {
        mobileMenuOpen,
        toggleMobileMenu,
        handleMobileItemClick,
        filteredElements,
        activeElement
      }
    },
  })
  </script>
  
  <style lang="scss" scoped>
  #mobile-topbar {
    height: 3.75rem;
    min-height: 3.75rem;
    background-color: $light-gray;
    color: $medium-gray;
    position: relative;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .left-section {
    display: flex;
    align-items: center;
  }
  
  .center-section {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .right-section {
    display: flex;
    align-items: center;
  }
  
  #mobile-topbar-logo {
    padding: 0;
  }
  
  .mobile-nav {
    display: none;
    position: fixed;
    top: 3.75rem;
    left: 0;
    width: 100%;
    background-color: $light-gray;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  
    &.mobile-nav-open {
      display: block;
      transform: translateY(0);
    }
  
    .menu {
      padding: 0;
      margin: 0;
      list-style: none;
    }
  
    .mobile-nav-item {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      width: 100%;
  
      a {
        display: flex;
        align-items: center;
        padding: 1rem;
        color: $medium-gray;
        text-decoration: none;
        gap: 1rem;
        width: 100%;
  
        &.selected {
          color: $petrol;
          background-color: rgba(0, 0, 0, 0.05);
        }
  
        i {
          width: 24px;
        }
      }
    }
  }
  </style>